import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';
import { useIconMaskId } from './useIconMaskId';

export function KeywordTrackerIcon(props: ToolIconProps) {
  const maskId = useIconMaskId('keyword-tracker');

  return (
    <ToolIconFrame {...props}>
      <defs>
        <mask id={maskId}>
          <rect width="48" height="48" fill="#fff" />
          <circle cx="10" cy="38.5" r="1.8" fill="#000" />
          <circle cx="24" cy="35" r="1.8" fill="#000" />
          <circle cx="38" cy="33" r="1.8" fill="#000" />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        <path
          d="M14.5 36.5v4c0 1.932-1.568 3.5-3.5 3.5H9a3.5 3.5 0 0 1-3.5-3.5v-4C5.5 34.568 7.068 33 9 33h2c1.932 0 3.5 1.568 3.5 3.5M28.5 29.5v11c0 1.932-1.568 3.5-3.5 3.5h-2a3.5 3.5 0 0 1-3.5-3.5v-11c0-1.932 1.568-3.5 3.5-3.5h2c1.932 0 3.5 1.568 3.5 3.5M42.5 25.058v15.885a3.06 3.06 0 0 1-3.058 3.058h-2.885a3.06 3.06 0 0 1-3.058-3.058V25.058A3.06 3.06 0 0 1 36.557 22h2.885a3.06 3.06 0 0 1 3.058 3.058"
          fill={toolIconPrimary}
        />
      </g>
      <path
        d="m41.344 4.639-.569 8.95-3.392-2.471A43.4 43.4 0 0 1 6.687 25.146l-.063-2.18A41.2 41.2 0 0 0 35.777 9.644l-3.7-2.947z"
        fill={toolIconSecondary}
        stroke={toolIconSecondary}
        strokeWidth="3.06"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
